webpackJsonp([6],{

/***/ 179:
/***/ (function(module, exports) {

module.exports = {"forma-equipos":"Form two teams","continuar":"Continue","azul":"Blue","naranja":"Orange"}

/***/ })

});


// WEBPACK FOOTER //
// static/js/6.9b0343927735ec3af495.js